<div
  class="blink blink-infinite"
  style="margin-right: 40px; margin-top: 8px; margin-left: 8px;"
>
  <h2 mat-dialog-title>Scanning for groks...</h2>
</div>
